import { BattleCharacter } from "./interfaces";
import { BehaviorSubject, Subject } from "rxjs";
import { concatAll, scan, share, shareReplay } from "rxjs/operators";

export default class AnimationQueue {
  public queue$: Subject<any>;
  public size$: BehaviorSubject<number>;

  private queuedSources: BattleCharacter[];

  constructor() {
    this.queue$ = new Subject().pipe(concatAll(), share()) as Subject<any>;
    this.size$ = new BehaviorSubject(0).pipe(
      scan((sum, next) => sum + next, 0),
      shareReplay(1)
    ) as BehaviorSubject<number>;
    this.queuedSources = [];
    this.queue$.subscribe(() => {
      this.size$.next(-1);
      this.queuedSources.pop();
    });
  }

  isQueued(source) {
    return this.queuedSources.some(queued => queued === source);
  }

  add(item$, source) {
    let itemToQueue$ = item$;
    this.queuedSources.unshift(source);
    this.size$.next(1);
    this.queue$.next(itemToQueue$);
  }
}
